// @givmo/social — what a host hands the package (SMM-WEB1): the organization and the person's
// effective permission set off the console's existing standing read. No class, no route literal.

import {
  SOCIAL_MANAGE_CONNECTIONS_PERMISSION,
  SOCIAL_PUBLISH_PERMISSION,
  SOCIAL_READ_PERMISSION,
} from './social-routes';

export interface SocialConfig {
  orgRef: string | null;
  /** `null` while the standing read is unsettled. */
  permissions: readonly string[] | null;
  /** The organization's name as its console shows it, so a connect can say whose accounts it
   *  chooses; `null` (or absent) while it is unknown. */
  orgName?: string | null;
}

/** May this person read the posts and accounts? An unsettled read offers the pages: the server
 *  refuses on its own, and the page then says so. */
export function canRead(config: SocialConfig): boolean {
  return config.permissions === null || config.permissions.includes(SOCIAL_READ_PERMISSION);
}

/** May this person write, schedule, publish, cancel and retry? (The same rule as `canRead`.) */
export function canPublish(config: SocialConfig): boolean {
  return config.permissions === null || config.permissions.includes(SOCIAL_PUBLISH_PERMISSION);
}

/** May this person connect, choose, reconnect and disconnect accounts? FAIL-CLOSED (§SMM-8: the
 *  custody affordances only for holders of `MANAGE_SOCIAL_CONNECTIONS`): an unsettled read offers
 *  none of them. */
export function canManageConnections(config: SocialConfig): boolean {
  return (
    config.permissions !== null && config.permissions.includes(SOCIAL_MANAGE_CONNECTIONS_PERMISSION)
  );
}
